import { makeStyles } from '@mui/styles';
import {
  Avatar,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { fontsize10, poppins500 } from 'theme/common.style';
import Dp from 'assets/dummy/buy.jpg';
import { getApiCall } from 'api/apiService';
import { toast } from 'react-toastify';
import { GET_BuyersCard } from 'constant/app.config';
import { useContext, useEffect, useState } from 'react';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import Loading from 'assets/images/loading.png';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const InitiateSign = ({ buyerid, proid, setOpenbinder }) => {
  const classes = useStyles();
  const history = useHistory();
  const [buyerDetails, setbuyerDetails] = useState({});
  const [pageloading, setPageloading] = useState(true);
  const { setLoaderConfig } = useContext(LoaderContext);

  const CircularProgressWithProfile = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={43}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={43}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  width: '36px',
                  height: '36px',
                  fontFamily: 'poppins',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt="Remy"
                src={props.profileImage}
                style={{
                  width: '36px',
                  height: '36px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  };

  const Getapifunctions = () => {
    getApiCall(GET_BuyersCard + `/Buyer/${buyerid}/${proid}`).then(
      async (res) => {
        setLoaderConfig({ isVisible: false });
        if (res?.tableData?.status == '-1') {
          toast.error(res?.tableData?.message, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
        } else {
          setbuyerDetails(res?.data?.BuyerDetails);
          setPageloading(false);
        }
      }
    );
  };

  useEffect(() => {
    Getapifunctions();
  }, []);
  return (
    <>
      <Grid container className={classes.subcontainer1}>
        <Grid item xs={12}>
          <Typography className={classes.Offersummary}>
            Offer Summary
          </Typography>
        </Grid>
        {pageloading ? (
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              height: '30vh',
              width: '100%',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Box>
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ width: '100px' }}
              />
            </Box>
          </Grid>
        ) : (
          <>
            <Grid container sx={{ padding: '5%' }}>
              <Grid item xs={12}>
                <Typography className={classes.Buyerdetails}>
                  Buyer Details
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.buyername}>
                <Grid item>
                  <Typography
                    component="th"
                    padding="none"
                    sx={{ width: '9%' }}
                  >
                    <Typography className={classes.userDetCont}>
                      <Typography className={classes.imageCont}>
                        <Typography
                          style={{
                            justifyContent: 'center',
                            position: 'relative',
                            alignItems: 'center',
                            paddingRight: '10px',
                            display: 'flex',
                            flexDirection: 'column !important',
                          }}
                        >
                          <CircularProgressWithProfile
                            value={buyerDetails?.profileActivity}
                            profileImage={buyerDetails?.user?.userProfile}
                            name={
                              buyerDetails?.user?.userName +
                              buyerDetails?.user?.userSurName
                            }
                          />
                          {/* <Avatar alt="Remy" src={Dp} /> */}
                        </Typography>
                      </Typography>
                    </Typography>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.Buyernameview}>
                    {buyerDetails?.user?.userName +
                      ' ' +
                      buyerDetails?.user?.userSurName}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.Buyerdetails}>
                  Contract Offer
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.buyername}>
                <Grid item sx={{ paddingLeft: '17%' }}>
                  <Typography className={classes.Buyernameview}>
                    {buyerDetails?.buyerOffer?.offerPrice}
                  </Typography>
                </Grid>
                <Grid item sx={{ paddingLeft: '5%' }}>
                  <Typography
                    sx={{ ...poppins500, ...fontsize10 }}
                    style={{
                      background:
                        buyerDetails?.buyerOffer?.isWinner == 1
                          ? 'rgba(108, 42, 210, 1)'
                          : buyerDetails?.buyerOffer?.logIsConditional === 1
                          ? 'rgba(237, 11, 11, 0.6)'
                          : 'rgba(16, 211, 94, 1)',
                      boder: '1px solid red',
                      borderRadius: '5px',
                      color: 'white',
                      padding: '4px 8px',
                      height: '22px',
                    }}
                  >
                    {buyerDetails?.buyerOffer?.isWinner == 1
                      ? 'Winner'
                      : buyerDetails?.buyerOffer?.logIsConditional == 1
                      ? 'Conditional'
                      : ' Unconditional'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.Buyerdetails}>
                  Legal Representative
                </Typography>
              </Grid>
              {buyerDetails?.solicitorDetails == null ? (
                <Grid item xs={12} sx={{ paddingLeft: '17%' }}>
                  <Typography className={classes.address}>
                    Not available{' '}
                  </Typography>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} className={classes.buyername}>
                    <Grid item>
                      <IconButton size="small" sx={{ padding: '0px' }}>
                        <Avatar
                          sx={{
                            width: 32,
                            height: 33,
                            backgroundColor: '#666666',
                            borderRadius: '6px',
                          }}
                        >
                          <Typography
                            fontWeight={500}
                            color="#FFFFFF"
                            fontFamily="Poppins"
                            fontSize="14px"
                          >
                            {buyerDetails?.solicitorDetails?.bsName[0].toUpperCase()}
                            {buyerDetails?.solicitorDetails?.bsSurname[0].toUpperCase()}
                          </Typography>
                        </Avatar>
                      </IconButton>
                    </Grid>
                    <Grid item sx={{ paddingLeft: '5%' }}>
                      <Grid item>
                        <Typography className={classes.address}>
                          {buyerDetails?.solicitorDetails?.bsName +
                            ' ' +
                            buyerDetails?.solicitorDetails?.bsSurname}
                        </Typography>
                      </Grid>
                      {buyerDetails?.solicitorDetails?.bsCompanyName !=
                        null && (
                        <Grid item>
                          <Typography className={classes.address}>
                            {buyerDetails?.solicitorDetails?.bsCompanyName}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  {buyerDetails?.solicitorDetails?.bsAddress && (
                    <>
                      <Grid item sx={{ paddingLeft: '17%', paddingTop: '5%' }}>
                        <Typography className={classes.Buyernameview}>
                          Address
                        </Typography>
                      </Grid>
                      <Grid item sx={{ paddingLeft: '17%' }}>
                        <Typography className={classes.address}>
                          {buyerDetails?.solicitorDetails?.bsAddress}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  <Grid item sx={{ paddingLeft: '17%', paddingTop: '5%' }}>
                    <Typography className={classes.address}>
                      Ph: {buyerDetails?.solicitorDetails?.bsMobile}
                    </Typography>
                  </Grid>
                  <Grid item sx={{ paddingLeft: '17%' }}>
                    <Typography className={classes.address}>
                      E: {buyerDetails?.solicitorDetails?.bsEmail}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={12} sx={{ paddingTop: '5%' }}>
              <Typography className={classes.Offersummary}>
                Related Conversations
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <MessagingContainer
                binders={true}
                UserCard={true}
                userEmail={buyerDetails?.userEmail}
                InitiateSign={true}
                proid={proid}
                setOpenbinder={setOpenbinder}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  subcontainer1: {
    width: '100%',
    borderTop: '1px solid rgb(165, 161, 161)',
    marginLeft: '-12px',
    padding: '5%',
    height: '74vh', // Set a fixed height
    overflowY: 'auto',
  },
  Offersummary: {
    fontSize: '20px !important',
    fontWeight: '500 !important',
    fontFamily: 'Poppins !important',
    color: 'rgb(51, 51, 51)',
    marginTop: '5% !important',
    marginBottom: '5% !important',
  },
  Buyerdetails: {
    display: 'block',
    fontSize: '16px !important',
    fontWeight: '500 !important',
    fontFamily: 'Poppins !important',
    color: 'rgb(51, 51, 51)',
    marginTop: '5% !important',
    marginBottom: '5% !important',
  },
  buyername: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  Buyernameview: {
    display: 'block',
    fontSize: '16px !important',
    fontWeight: '400 !important',
    fontFamily: 'Poppins !important',
    color: 'rgb(51, 51, 51)',
    marginTop: '5% !important',
    marginBottom: '5% !important',
  },
  address: {
    fontSize: '16px !important',
    fontWeight: '400 !important',
    fontFamily: 'Poppins !important',
    color: 'rgb(51, 51, 51)',
  },
  imageCont: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  userDetCont: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: 'none',
    width: '100%',
  },
}));
export default InitiateSign;
